import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "getHeaderTitle", "actionMetadata"];
import PropTypes from 'prop-types';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import WebhookActionMetadata from 'automation-ui-action-features/actions/webhook/records/WebhookActionMetadata';
import WebhookActionSummary from 'automation-ui-action-features/actions/webhook/WebhookActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function WebhookActionCard(_ref) {
  let {
      actionId,
      getHeaderTitle,
      actionMetadata
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId: actionId
    }),
    content: /*#__PURE__*/_jsx(WebhookActionSummary, {
      actionMetadata: actionMetadata
    })
  }));
}
WebhookActionCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(WebhookActionMetadata).isRequired,
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default WebhookActionCard;